/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, Dropdown } from 'react-bootstrap';
import './TutoAccueil.scss';
import dataTutoEnglish from './dataTutoEnglish';

const TutoAccueil = function TutoAccueil() {
  const [category, setCategory] = React.useState('all');
  const navigate = useNavigate();

  return (
    <div className="tuto">
      <h1 className="titletuto">Welcome to our Tutorials page</h1>
      <p>
        You want to do it yourself ? Find on this page all our tutorials to
        realize all your projects.
      </p>
      <div className="drop">
        <Dropdown>
          <Dropdown.Toggle className="buttontuto" id="dropdown-basic">
            Category
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setCategory('plumbing')}>
              Plumbing
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setCategory('exteriors')}>
              Exteriors
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setCategory('interiors')}>
              Interiors
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setCategory('decoration')}>
              Decoration
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setCategory('all')}>
              All tutorials
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="tutocard">
        {dataTutoEnglish
          .filter((data) => category === 'all' || data.category === category)
          .map((data) => (
            <Card style={{ width: '18rem' }}>
              <Card.Img variant="top" src={data.imgIntro} />
              <Card.Body>
                <Card.Title>{data.nomTuto}</Card.Title>
                <Card.Text>{data.intro}</Card.Text>
                <Card.Text>difficulty : {data.difficulty}</Card.Text>
                <Card.Text>time : {data.time}</Card.Text>
                <Button
                  className="buttontuto"
                  onClick={() => navigate(`/allamano/${data.slug}`)}
                >
                  Let's try it !
                </Button>
              </Card.Body>
            </Card>
          ))}
      </div>
    </div>
  );
};

export default TutoAccueil;
